import { SortDirection } from '@angular/material/sort';

import { BaseListFilter } from '../../../models/base-list-filter.model';
import { CreditCardStatusEnum } from './credit-card-status.enum';

export class CreditCardsFilter extends BaseListFilter {
  userId?: number;
  status?: CreditCardStatusEnum | null = null;
  userName?: string;
  createdAtFrom?: Date;
  createdAtTo?: Date;

  constructor(
    public sortBy: string = 'credit_card.id',
    public sortDirection: SortDirection = 'desc',
  ) {
    super();
  }
}
